import { loadingLottie } from "assets/lottie";
import Lottie from "lottie-react";
import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { useParams } from "react-router-dom";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

type TParams = {
  key: string;
};

const terms_url = [
  "https://makemywedding.s3.ap-northeast-2.amazonaws.com/terms/1_makemywedding.pdf",
  "https://makemywedding.s3.ap-northeast-2.amazonaws.com/terms/terms_of_service.pdf",
];
export default function PDFPage() {
  const { key } = useParams<TParams>();
  const [numPages, setNumPages] = useState(0);
  const url = terms_url;
  function onDocumentLoadSuccess({ numPages }: { numPages: number }) {
    setNumPages(numPages);
  }
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <Document
        file={url[Number(key) - 1]}
        onLoadSuccess={onDocumentLoadSuccess}
        loading={
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "80vh",
              padding: 50,
            }}
          >
            <Lottie animationData={loadingLottie} loop={true} />
          </div>
        }
      >
        {[...Array(numPages).keys()].map((page) => (
          <Page key={page} pageNumber={page + 1} width={400} />
        ))}
      </Document>
    </div>
  );
}
